import React from 'react';
import PropTypes from 'prop-types';
import withStyles from '@material-ui/core/styles/withStyles';
import { Checkbox as MuiCheckbox } from '@material-ui/core';

class Checkbox extends React.Component {
    static propTypes = {
        classes: PropTypes.object.isRequired
    };

    constructor (props) {
        super(props);
    }

    render () {
        const { classes, ...otherProps } =this.props;

        return (
            <MuiCheckbox
                classes={{
                    root: classes.checkboxRoot
                }}
                {...otherProps}
            />
        );
    }
}

const style = theme => ({
    checkboxRoot: {
        padding: 5
    }
});

export default withStyles(style)(Checkbox);